import { createQueryPreloader } from '@apollo/client';
import { createFileRoute } from '@tanstack/react-router';

// relative imports
import AccountSettingsPage from '../../../components/account-management/settings/AccountSettingsPage';
import LoadingPage from '../../../components/shared/page-components/LoadingPage';
import { currentAccountIdVar } from '../../../data/apollo/cache/reactiveVars';
import { ALL_USERS_QUERY } from '../../../data/apollo/queries';
import { isModuleEnabled } from '../../../data/app-config/configs/configUtilities';

export const Route = createFileRoute('/_authenticated/settings')({
  component: AccountSettingsPage,
  pendingComponent: () => <LoadingPage loadingPage />,
  staticData: {
    configPageId: 'account-settings',
    meta: {
      title: 'Account Settings | Ledgible',
    },
  },
  beforeLoad: ({ context: { apolloClient } }) => {
    if (isModuleEnabled({ moduleName: 'teamManagement' })) {
      const preloadQuery = createQueryPreloader(apolloClient);
      const usersQueryRef = preloadQuery(ALL_USERS_QUERY, {
        variables: {
          accountId: currentAccountIdVar(),
        },
        fetchPolicy: 'cache-and-network',
      });

      return { usersQueryRef };
    }

    return {};
  },
});
